import { DigestTime } from "@uic/adapters/slorgproto";
import alarmSvg from "@uic/assets/icons/alarm-bold.svg?raw";

export const pushLabel = {
  key: "domain.push.label",
  icon: alarmSvg,
};

/**
 * The translation key naming each digest time.
 *
 * The name is the whole of the choice the user makes; the clock time beside it
 * comes from the server, so retiming a block never touches this file.
 * @type {Readonly<Record<number, string>>}
 */
export const DIGEST_TIME_KEYS = Object.freeze({
  [DigestTime.DAYBREAK]: "domain.push.digestTimes.daybreak",
  [DigestTime.MORNING]: "domain.push.digestTimes.morning",
  [DigestTime.MIDDAY]: "domain.push.digestTimes.midday",
  [DigestTime.AFTERNOON]: "domain.push.digestTimes.afternoon",
  [DigestTime.EVENING]: "domain.push.digestTimes.evening",
  [DigestTime.NIGHT]: "domain.push.digestTimes.night",
});
